<template>
  <div :style="{ 'position': position }" class="header el-col-24">
    <div class="header_main el-col-24 el-col-offset-0">
      <img src="@/assets/images/logo_top1.png" alt="" class="logo_top">
      <div class="goUl">
        <div @click="goMy" class="goLi">
          <i class="icon el-icon-s-management icon-liebiao"></i>
          未匹配资源库
          <div v-if="store.state.index" class="dian"></div>
        </div>
        <div @click="goLive" class="goLi">
          <img src="@/assets/images/live.png" alt="" class="liveIcon">
          课程直播
        </div>
        <div @click="jumpHW" class="goLi">
          <i style="font-size:18px;color:#f56c6c;" class="el-icon-s-platform"></i>
          我的工作台
        </div>
        <div @click="inVideo" class="goLi">
          <i class="el-icon-video-play"></i>
          使用说明
        </div>
      </div>
      <div class="right_box">
        <img src="@/assets/images/user_img.png" alt="" class="user_img">
        <div class="user_title">{{ name }}</div>
        <div @click="passwordStatus = true" class="set_password">修改密码</div>
        <div @click="outLogin" class="user_out">退出</div>
        <!--  修改密码-->
        <el-dialog title="修改密码" :visible.sync="passwordStatus" width="20%" center>
          <div class="tk_inp">
            旧密码：
            <el-input type="password" disable v-model="OPassword" placeholder="请输入旧密码"></el-input>
          </div>
          <div class="tk_inp">
            新密码：
            <el-input type="password" disable v-model="passwordOne" placeholder="请输入新密码"></el-input>
          </div>
          <div class="tk_inp">
            确认新密码：
            <el-input type="password" disable v-model="password" placeholder="请重复输入新密码"></el-input>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="passwordStatus = false">取 消</el-button>
            <el-button type="primary" @click="setPassword">确 定</el-button>
          </span>
        </el-dialog>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      name: this.store.state.Name,
      passwordStatus: false,
      passwordOne: '',
      password: '',
      OPassword: '',
      position: 'fixed'
    }
  },
  watch: {
    passwordStatus(Val, oldVal) {
      if (Val) {
        this.position = 'inherit'
      } else {
        this.position = 'fixed'
      }
    }
  },
  mounted() {
    var that = this;
    that.name = localStorage.getItem('Name');
  },
  methods: {
    // 退出登录
    outLogin() {
      var that = this;
      this.$confirm('是否要退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        that.axios.post(window.url + 'SignOut', {}).then(res => {
          var data = res.data;
          that.returnCode(data.result);
          localStorage.removeItem('token');
          localStorage.removeItem('UserID');
          localStorage.removeItem('Name');
          localStorage.removeItem('TeacherID');
          localStorage.removeItem('SchoolID');
          sessionStorage.removeItem('un');
          sessionStorage.removeItem('Md5');
          this.$router.replace({ name: 'Login' });
          location.reload();
        }).catch(error => {
          that.$message.error('您的网络开小差了！')
        });

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '退出失败'
        });
      });
    },
    inVideo() {
      // console.log("怎么回事?")
      this.$router.push({ name: 'pcVideo' });
    },
    // 修改密码
    setPassword() {
      var that = this;
      if (that.OPassword.trim().length == 0 || that.password.trim().length == 0) {
        that.$message.error('密码不能为空！');
        return;
      }
      if (that.password.trim() != that.passwordOne.trim()) {
        that.$message.error('两次密码输入不一致，请再次输入！');
        that.password = '';
        that.passwordOne = '';
        return;
      }
      this.axios.post(window.url + 'ChangePassword', {
        Password: that.password.trim(),
        OPassword: that.OPassword.trim()
      }).then(res => {
        var data = res.data;
        if (data.result == 500 || data.result == 602 || data.result == 600) {
          that.$message.success(data.message);
          return;
        }
        that.$message.success(data.message);
        that.passwordStatus = false;
        this.$router.replace({ name: 'Login' });
      }).catch(error => {
        that.$message.error('您的网络开小差了！')
      });
    },
    // 课程列表
    goList() {
      this.$parent.setChapterID();
    },
    // 我的资源库
    goMy() {
      this.$router.replace({ name: 'ResourceList' });
    },
    // 直播
    goLive() {
      this.$router.replace({ name: 'LiveList' });
    },
    // 返回值调用
    returnCode(code, msg) {
      var that = this;
      if (code != 200) {
        if (code == 201) {
          this.$router.replace({ name: 'Login' });
        }
        that.$message.error(msg);
        return;
      }
    },
    //跳到在线作业
    jumpHW() {
      let baseUrl; // 本机. http://192.168.7.110:8080/
      // let baseUrl="http://saastest.jianxiangjiaoyu.com/" // 在线作业测试服务.
      // let baseUrl="http://192.168.7.110:8080/"    // 在线作业正式服务.
      // console.log(this.store, sessionStorage["Md5"]);
      let localHref = location.href.indexOf("localhost");
      if (localHref < 0) {
        if (window.url.indexOf("test") > -1) {
          baseUrl = "https://hwtest.jianxiangjiaoyu.com";
        } else {
          baseUrl = "https://hw.jianxiangjiaoyu.com";
        }
      } else {
        //http://192.168.7.110:8080/#/login
        baseUrl = "http://localhost:8849";
      }
      //console.log(baseUrl);
      let url = `${baseUrl}#/aLogin?un=${sessionStorage["un"]}&md5=${sessionStorage["Md5"]}`;
      //console.log(url);
      //return;
      window.location.replace(url, "self");
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  height: 70px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  background-color: #ffffff;
  border-bottom: 1px solid #dedede;
  -webkit-box-shadow: 0 0 2px 1px #dedede;
  -moz-box-shadow: 0 0 2px 1px #dedede;
  box-shadow: 0 0 2px 1px #dedede;

  .header_main {
    display: block;
    height: 70px;
    line-height: 70px;
    padding: 0 20px;

    .goUl {
      height: 70px;
      float: left;
      margin-left: 130px;
      display: inline-block;
      vertical-align: top;

      .goLi {
        display: inline-block;
        height: 70px;
        line-height: 70px;
        cursor: pointer;
        font-size: 16px;
        text-align: left;
        margin-right: 30px;
        position: relative;

        .icon-liebiao {
          color: #66BA8A;
        }

        .icon-wenjianjia {
          color: #EDA129;
        }

        .dian {
          position: absolute;
          top: 24px;
          right: -5px;
          width: 7.5px;
          height: 7.5px;
          background-color: #E66262;
          -webkit-border-radius: 50%;
          -moz-border-radius: 50%;
          border-radius: 50%;
        }

        .liveIcon {
          width: 18px;
          display: inline-block;
          vertical-align: middle;
          margin-bottom: 6px;
        }
      }
    }

    .logo_top {
      width: 190px;
      height: 34px;
      margin-top: 18px;
      float: left;
    }

    .right_box {
      float: right;

      .tk_inp {
        line-height: 50px;
      }

      .user_out {
        margin-left: 50px;
        display: inline-block;
        vertical-align: top;
        cursor: pointer;
      }

      .set_password {
        margin-left: 50px;
        display: inline-block;
        vertical-align: top;
        cursor: pointer;
      }

      .user_title {
        display: inline-block;
        vertical-align: top;
        cursor: pointer;
      }

      .user_img {
        width: 32px;
        height: 32px;
        margin-right: 10px;
        margin-top: 18px;
        display: inline-block;
        vertical-align: top;
        cursor: pointer;
      }
    }

    @media screen and (min-width: 992px) and (max-width: 1300px) {
      .goUl {
        margin-left: 80px;
      }

      .right_box {
        .user_out {
          margin-left: 20px;
        }
      }


    }

  }
}
</style>
<style lang="less">
.right_box {
  .el-dialog__body {
    padding: 10px 30px !important;
    overflow-y: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue